/*doc

 Renders a widget containing author name, questions answered
 most recent book, picture, Ask button if they are currently enabled
 for Ask The Author, and their most recently answered question.

 */

import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import UserIcon from "../../user/user_icon";
import { ICON_SIZES } from "../../../modules/shape_icon_values";
import React from "react";
import Spoiler from "../../user_content/spoiler";
import FlagForAbuseLink from "../../flagged_resources/flag_for_abuse_link";
import ExpandableHtml from "../../user_content/expandable_html";
import LikesAndCommentsFooter from "../../like/likes_and_comments_footer";
import SpoilerWarning from "./shared/spoiler_warning";

export default GrComponentFactory.createClass({
  displayName: "AskTheAuthorCommunityQuestionAnswerContainer",

  propTypes: {
    authorUser: GrPropTypes.user().isRequired,
    currentUser: GrPropTypes.user().isRequired,
    authorTagline: React.PropTypes.string.isRequired,
    ATAenabled: React.PropTypes.bool.isRequired,
    questionURL: React.PropTypes.string.isRequired,
    answerURL: React.PropTypes.string.isRequired,
    answersCountText: React.PropTypes.string,
    communityQuestionText: React.PropTypes.string.isRequired,
    communityAnswerText: React.PropTypes.shape(GrPropTypes.truncatedHtml()),
    questionSpoiler: React.PropTypes.bool.isRequired,
    answerSpoiler: React.PropTypes.bool.isRequired,
    flagForAbuseUrl: React.PropTypes.string.isRequired,
    like: GrPropTypes.like().isRequired,
    comment: GrPropTypes.comment().isRequired,
  },
  renderAuthorIconAndAskButton(){
    return (
      <div className="askTheAuthorCommunityQuestionAnswerContainer askTheAuthorCommunityQuestionAnswerContainer__iconColumnWidth">
        <div className="gr-mediaFlexbox__media gr-mediaFlexbox__media--alignSelfCenter">
          <UserIcon user={this.props.authorUser}
                    size={ICON_SIZES.LARGE}/>
        </div>
        {this.props.ATAenabled ?
          <a href={this.props.questionURL}
             className="gr-button askTheAuthorCommunityQuestionAnswerContainer askTheAuthorCommunityQuestionAnswerContainer__button askTheAuthorFeaturedListItemContainer__button"
             aria-label="Ask {this.props.authorUser.name} a question">
            Ask </a> : null }
      </div>
    );
  },
  renderAuthorAnswer(){
    return (
      <div className="askTheAuthorCommunityQuestionAnswerContainer askTheAuthorCommunityQuestionAnswerContainer__answerText">
            <span className="askTheAuthorCommunityQuestionAnswerContainer askTheAuthorCommunityQuestionAnswerContainer__authorAnswer">
              {this.props.authorUser.viewableName}: </span> {this.props.answerSpoiler ?
        <Spoiler html={this.props.communityAnswerText.fullContentText}
                 spoilerWarning={<SpoilerWarning spoilerType="answer"/>} /> :
        <ExpandableHtml html={this.props.communityAnswerText.fullContentText}
                        truncatedHtml={this.props.communityAnswerText.html}/>
      }
      </div>
    );
  },
  renderAuthorQuestion(){
    return (
      <div className="u-marginTopSmall askTheAuthorCommunityQuestionAnswerContainer askTheAuthorCommunityQuestionAnswerContainer__questionText">
        {this.props.questionSpoiler ?
          <Spoiler html={this.props.communityQuestionText}
                   spoilerWarning={<SpoilerWarning spoilerType="question"/>} /> :
          this.props.communityQuestionText}
      </div>
    );
  },
  renderFlagForAbuseUrl(){
    return (
      <div className="gr-comment gr-comment__rightSideInformation">
        <FlagForAbuseLink flagForAbuseUrl={this.props.flagForAbuseUrl} />
      </div>
    );
  },
  renderLikesAndCommentsFooter(){
    return (
      <div className="u-marginTopXSmall u-marginBottomSmall">
        <LikesAndCommentsFooter
          currentUser={this.props.currentUser}
          resourceKey={this.props.like.key}
          resourceLabel={this.props.like.label}
          isLikeable={this.props.like.isLikeable}
          showAsLink={true}
          comment={this.props.comment}
        />
      </div>
    );
  },
  render() {
    return (
      <div className="gr-mediaFlexbox">
        {this.renderAuthorIconAndAskButton()}
        <div className="gr-mediaFlexbox__desc">
          <a href={this.props.authorUser.profileUrl}
             className="gr-hyperlink gr-hyperlink--bold askTheAuthorFeaturedListItemContainer__title">
            {this.props.authorUser.viewableName} </a>
          <div className="askTheAuthorCommunityQuestionAnswerContainer askTheAuthorCommunityQuestionAnswerContainer__answersCount">
            <a href={this.props.answerURL}
               className="gr-hyperlink">
              {this.props.answersCountText} </a>
          </div>
          <div>
            <small>
              {this.props.authorTagline}
            </small>
          </div>
          {this.renderAuthorQuestion()}
          {this.renderAuthorAnswer()}
          {this.renderFlagForAbuseUrl()}
          {this.renderLikesAndCommentsFooter()}
        </div>
      </div>
    );
  },
});
